




































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
/* api */
import VarietyDetailApi from '@/app/model/api/varietyDetailApi'
import VarietyCreateApi from '@/app/model/api/varietyCreateApi'
import VarietyEditApi from '@/app/model/api/varietyEditApi'
import VarietyDeleteApi from '@/app/model/api/varietyDeleteApi'
import AiAdviceApi from '@/app/model/api/aiAdviceApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import Local from '@/app/module/local'
import Session from '@/app/module/session'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    DeleteModal,
    Error409Modal,
    Loading,
    ErrorInfo,
    ConfirmModal
  }
})
export default class VarietyCreate extends Vue {
  private stageIsVaildFlags: any = []
  private constantValue: any = []
  private errorMessages: any = {}
  private alertText: string = ''
  private alertTitle: string = ''
  private confirmMessage: string = '<p>生育ステージの「利用する」を変更している場合は<br/>関連する品種生育マスタの生育ステージの有効/無効も変更されます。<br/>よろしいですか？</p>'
  private aiAdvice: any = []
  private saveData: any = {}
  private varietyData: any = {
    variety: {
      variety_name: '',
      remarks: '',
      ai_advice_id: null
    },
    variety_stages: []
  }
  /* 表示非表示 */
  private showServerErrorModal: boolean = false
  private showDeleteModal: boolean = false
  private showLoading: boolean = true
  private isEdit: boolean = false
  private isError: any = {}
  private isDisable: any = {}
  private showError409Modal: boolean = false
  private showSaveVerifyModal: boolean = false
  private copyFlag: boolean = false
  private show400ErrorMessage: boolean = false

  private get route (): any {
    return this.$route.path
  }
  @Watch('route')
  getRoute (route: string) {
    if (this.copyFlag && route === '/master/variety/create') {
      location.reload()
    }
  }

  created () {
    // システム定義情報取得
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    // AIアドバイス取得
    this.getAiAdvice()
    if (this.$route.path === '/master/variety/create') {
      this.isEdit = false

      // コピーがあれば表示、なければデフォルト表示
      const copyData = JSON.parse(Session.getCopyVarietyData()!)
      if (copyData === undefined || copyData === null) {
        this.stageIsVaildFlags = [1, 3, 4, 5, 6, 7, 8, 9, 10, 11]
        // システム定義を使ってステージ配列を作成
        for (let j in this.constantValue.sys_variety_stages) {
          let isValid
          if (this.constantValue.sys_variety_stages[j].sys_variety_stage_id === 1 ||
              this.constantValue.sys_variety_stages[j].sys_variety_stage_id === 11) {
            isValid = 1
          } else {
            isValid = 0
          }
          // 収穫適期以外は「生育+display_number」を初期値とする
          let stageName = ''
          if (this.constantValue.sys_variety_stages[j].sys_variety_stage_id === 11) {
            stageName = this.constantValue.sys_variety_stages[j].variety_stage_name
          } else {
            stageName = '生育' + this.constantValue.sys_variety_stages[j].display_number
          }
          this.varietyData.variety_stages.push({
            step: this.constantValue.sys_variety_stages[j].sys_variety_stage_id,
            is_valid: isValid,
            stage_name: stageName
          })
        }
        // ステージ利用可否設定
        for (let i in this.varietyData.variety_stages) {
          const data = this.varietyData.variety_stages[i]
          if (this.stageIsVaildFlags.includes(data.step)) {
            this.$set(this.isDisable, 'is_valid' + data.step, false)
          } else {
            this.$set(this.isDisable, 'is_valid' + data.step, true)
          }
        }
      } else {
        this.varietyData = copyData
        // 品種名に（コピー）と表示
        this.varietyData.variety.variety_name = this.varietyData.variety.variety_name + '（コピー）'
        sessionStorage.removeItem('varietyCopyData')
        // ステージ利用可否設定
        for (let i in this.varietyData.variety_stages) {
          if (this.varietyData.variety_stages[i].is_valid === 1) {
            this.stageIsVaildFlags.push(this.varietyData.variety_stages[i].step)
            this.$set(this.isDisable, 'is_valid' + this.varietyData.variety_stages[i].step, false)
          } else {
            this.$set(this.isDisable, 'is_valid' + this.varietyData.variety_stages[i].step, true)
          }
        }
      }
      this.showLoading = false
    } else {
      this.isEdit = true
      this.getVarietyList()
    }
  }

  // AIアドバイス取得
  private getAiAdvice () {
    (async () => {
      const result = await AiAdviceApi.getAiAdvice({
        word: '',
        order_name: 'name',
        sort: 'asc'
      })

      if (result.isOk()) {
        this.aiAdvice = result.getPayload().ai_advice
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private getVarietyList () {
    (async () => {
      const result = await VarietyDetailApi.getVarietyDetail(this.$route.params.variety_id)
      if (result.isOk()) {
        this.varietyData = result.getPayload()
        // ステージ利用可否設定
        for (let i in this.varietyData.variety_stages) {
          if (this.varietyData.variety_stages[i].is_valid === 1) {
            this.stageIsVaildFlags.push(this.varietyData.variety_stages[i].step)
            this.$set(this.isDisable, 'is_valid' + this.varietyData.variety_stages[i].step, false)
          } else {
            this.$set(this.isDisable, 'is_valid' + this.varietyData.variety_stages[i].step, true)
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.isvarietyCreate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }

    this.saveData = {
      variety: this.varietyData.variety,
      variety_stages: this.varietyData.variety_stages
    }

    if (this.isEdit) {
      this.showSaveVerifyModal = true
    } else {
      this.showLoading = true
      this.varietyCreate()
    }
  }

  private async varietyCreate () {
    const result = await VarietyCreateApi.doVarietyCreate(this.saveData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/variety').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async varietyEdit () {
    this.showLoading = true
    const result = await VarietyEditApi.doVarietyEdit(this.$route.params.variety_id, this.saveData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/variety').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
    this.showSaveVerifyModal = false
  }

  private changeValid (step: number) {
    // ステージ利用可否設定
    if (this.stageIsVaildFlags.includes(step)) {
      this.$set(this.isDisable, 'is_valid' + step, false)
    } else {
      this.$set(this.isDisable, 'is_valid' + step, true)
    }
  }

  private isvarietyCreate () {
    // リセット
    this.errorMessages = {}

    const varietyNameFlag = Validator.validateInputVarietyName('varietyNameErrorMessage', this.varietyData.variety.variety_name)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())
    let isError = true

    for (let i in this.varietyData.variety_stages) {
      const data = this.varietyData.variety_stages[i]
      // ステージ利用可否設定
      if (this.stageIsVaildFlags.includes(data.step)) {
        data.is_valid = 1
      } else {
        data.is_valid = 0
      }
      // ステージ名バリデーション
      if (data.stage_name === '' && data.is_valid === 1) {
        this.$set(this.errorMessages, 'varietyStageNameErrorMessage', 'ステージ名は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'stage_name' + i, true)
      } else {
        this.$set(this.isError, 'stage_name' + i, false)
      }
    }

    return varietyNameFlag && isError
  }

  private doVarietyDelete () {
    (async () => {
      this.showLoading = true
      const result = await VarietyDeleteApi.doVarietyDelete(this.$route.params.variety_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/variety').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertTitle = errorData.alertTitle
          this.alertText = errorData.alertText
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private createCopy () {
    Session.setCopyVarietyData(JSON.stringify(this.varietyData))
    this.copyFlag = true
    this.$router.push('/master/variety/create').catch(e => {})
  }

  private doCancel () {
    this.$router.push('/master/variety').catch(e => {})
  }
}
